import React from "react";
import legionLogo from "../../../images/icons/vertical-grey.png";
import gitHubLogo from "../../../images/icons/icons-github.png";
import gitLabLogo from "../../../images/icons//icons-gitlab.png";
import { Link } from "react-router-dom";

const Experience = () => {
  return (
    <>
      <section className="experience-section">
        <h1>Досвід</h1>
        <div className="section-content">
          <p>
            Наразі у мене немає комерційного досвіду, оскільки я тільки
            завершила курс по напрямку.
          </p>
          <p>
            Проте, зараз я співпрацюю не на комерційних засадах із
            <Link
              to={{
                pathname: "//www.legion-marketing.com.ua/",
              }}
              target="_blank"
              className="legion-marketing"
            >
              <img className="legion-logo" src={legionLogo} alt="legion-logo" />
              <span>Legion-marketing agency</span>
            </Link>
            , і займаюся розробкою їхнього сайту на базі React.
          </p>
          <p>
            Поки що можу запропонувати переглянути в якості досвіду роботи, над
            якими я працювала напротязі курсу, відповідно до поставлених задач:
          </p>
          <ul className="experience-list">
            <li className="experience-item git-hub">
              <Link
                to={{
                  pathname: "//github.com/ztDiana",
                }}
                target="_blank"
              >
                <img
                  className="experience-item-img"
                  src={gitHubLogo}
                  alt="gitHub-logo"
                />
                https://github.com/ztDiana
              </Link>
            </li>
            <li className="experience-item git-hub">
              <Link
                to={{
                  pathname: "//gitlab.com/dzayats",
                }}
                target="_blank"
              >
                <img
                  className="experience-item-img"
                  src={gitLabLogo}
                  alt="gitLab-logo"
                />
                https://gitlab.com/dzayats
              </Link>
            </li>
          </ul>
          <p>
            Резюме, яке ви переглядаєте, також відповідно моя робота на базі
            React
          </p>
        </div>
      </section>
    </>
  );
};
export default Experience;
